/**
 * godRays — soft ray_ribbon shafts (screen blend) that breathe in alpha.
 * Migrated 1:1 from AtmosphereLayer.buildGodRays. Under reduced motion the shafts hold a steady
 * alpha midway through the breathe (as fireflies and heat haze hold still).
 */
import { registerEffect, makeContentHandle, type EffectBuilder } from '../effectBuilders';
import { placeGodRays } from '../atmospherePlacement';
import { createGlowSprite } from '../../vfx/glowSpriteFactory';
import { Z_LAYERS } from '../../../rendering/Z_LAYERS';
import type { ISprite } from '../../../rendering/IRenderer';
import { getMotionPrefs } from '../../../systems/accessibility/motionPrefs';

const buildGodRays: EffectBuilder = (layer, ctx) => {
  if (layer.kind !== 'godRays') return null;
  const sprites: ISprite[] = [];
  const reduce = getMotionPrefs().reduceMotion; // read once at build time
  for (const r of placeGodRays(layer, ctx.region, ctx.seed)) {
    const s = createGlowSprite({ x: r.x, y: r.y, size: r.width, color: r.color, alpha: r.alphaMin, textureKey: 'ray_ribbon', parent: ctx.layerContainer });
    if (!s) break;
    sprites.push(s);
    s.setDisplaySize(r.width, r.height);
    s.setAngle(r.tiltDeg);
    // Breathe alpha slowly (the canopy-light shimmer).
    if (reduce) s.setAlpha((r.alphaMin + r.alphaMax) / 2);
    else s.tween({ alpha: r.alphaMax }, { durationMs: r.periodMs / 2, ease: 'sineInOut', yoyo: true, repeat: -1 });
  }
  return makeContentHandle({ sprites });
};

registerEffect({ kind: 'godRays', build: buildGodRays, depth: Z_LAYERS.ATMOSPHERE });
